import React from 'react';
import {
  Container,
  StyledButton,
  Wrapper,
  LinkStyled,
  StyledImage,
  Hero,
  ButtonsContainer,
  CreditsButton,
  TitleContainer
} from './styles';
import images from '../Assets/export.assets';

export default function Content() {
  return (
    <Container>
      <Wrapper>
        <Hero>
          <TitleContainer>
            <StyledImage
              src={images.logoCampanha}
              alt="Logo da Campanha defenda-se em amarelo"
            />
            <h1>
              <span>Práticas</span>
              <br />
              <span>Educativas</span>
            </h1>
          </TitleContainer>
          <StyledImage
            className="logo-marista"
            src={images.logoMarista}
            alt="Logo do marista em azul"
            width={136}
            height={49}
          />
        </Hero>
        <ButtonsContainer>
          <LinkStyled to="/apresentacao/inicio">
            <StyledButton>
              Iniciar
            </StyledButton>
          </LinkStyled>
          <LinkStyled to="/expediente">
            <CreditsButton>
              Expediente
            </CreditsButton>
          </LinkStyled>
        </ButtonsContainer>
      </Wrapper>
    </Container>
  );
}
